module.exports = __webpack_public_path__ + "img/tab_button_img3_mobile.bf83800d.png";